<template>
  <div>
    <b-row>
      <b-col sm="4">
        <b-input-group prepend="Titulo" size="sm" class="mt-4">
          <b-form-input
            v-model="translations[language].title"
            v-validate.initial="'required|max:30'"
            type="text"
            name="title"
            size="sm"
            :disabled="disabledInputs"
          />
        </b-input-group>
        <b-form-invalid-feedback
          :state="errors.collect('title').length === 0"
        >{{errors.first('title')}}</b-form-invalid-feedback>
      </b-col>
      <b-col sm="4">
        <b-input-group prepend="sub Titulo" size="sm" class="mt-4">
          <b-form-input
            v-bind:value="subTitle"
            v-on:input="input => this.$emit('update:subTitle',input)"
            v-validate.initial="'required|max:30'"
            type="text"
            name="subTitle"
            size="sm"
            :disabled="disabledInputs"
          />
        </b-input-group>
        <b-form-invalid-feedback
          :state="errors.collect('subTitle').length === 0"
        >{{errors.first('subTitle')}}</b-form-invalid-feedback>
      </b-col>
      <b-col sm="4">
        <b-input-group prepend="Bold Desc." size="sm" class="mt-4">
          <b-form-input
            v-model="translations[language].bold_desc"
            v-validate.initial="'required'"
            type="text"
            name="boldDesc"
            size="sm"
            :disabled="disabledInputs"
          />
        </b-input-group>
        <b-form-invalid-feedback
          :state="errors.collect('boldDesc').length === 0"
        >{{errors.first('boldDesc')}}</b-form-invalid-feedback>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-input-group prepend="Descriçao" size="sm" class="mt-4">
          <b-form-textarea
            v-model="translations[language].description"
            v-validate.initial="'required'"
            type="text"
            name="description"
            size="sm"
            :disabled="disabledInputs"
            rows="5"
            max-rows="8"
            style="height: 178px;"
          />
        </b-input-group>
        <b-form-invalid-feedback
          :state="errors.collect('description').length === 0"
        >{{errors.first('description')}}</b-form-invalid-feedback>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: "translationsEvent",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: true
    },
    boldDesc: {
      type: String,
      required: true
    },
    disabledInputs: {
      type: Boolean,
      required: true
    },
    language: {
      type: String,
      required: true
    },
    translations: { type: Object, required: true }
  }
};
</script>